$('#login .lang .select').on("change", function () {
    location.href = $('#login .lang .select option:selected').val();
});